/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, { useCallback, useMemo } from 'react';
import { Frame, Panel, Link } from '@kajabi/sage-react';
import './index.scss';

import { trackOptimizelyEvents } from 'common/services/product_analytics';
import { useCheckout } from '../../context';
import { buildGoogleSignupUrl } from '../../services/CheckoutService';
import { GOOGLE_SIGNUP_BUTTON_CLICKED } from '../../helpers/constants';

export const GoogleButton = () => {
  const {
    social,
    isTwoStepsSignup,
    isTwoStepsSignupSecondStep,
    socialGoogleEnabled,
    auth0ClientId,
    auth0ClientDomain,
    planInfo,
    formParams: { signup_source: originalSignupSource }
  } = useCheckout();

  const withGoogleUrl = useMemo(
    () => buildGoogleSignupUrl({
      planInfo,
      originalSignupSource,
      auth0ClientId,
      auth0ClientDomain
    }), [
      planInfo,
      originalSignupSource,
      auth0ClientId,
      auth0ClientDomain
    ]);

  const trackGoogleSignupClickAndRedirect = useCallback(() => {
    trackOptimizelyEvents(GOOGLE_SIGNUP_BUTTON_CLICKED);
    setTimeout(() => {
      window.location.href = withGoogleUrl;
    }, 300);
  }, [withGoogleUrl]);

  const renderGoogleSocialButton = () => {
    if (!isTwoStepsSignup()) {
      return null;
    }

    if (!socialGoogleEnabled) {
      return null;
    }

    if (social) {
      return null;
    }

    if (isTwoStepsSignupSecondStep()) {
      return null;
    }

    return (
      <>
        <Frame direction={Frame.DIRECTIONS.HORIZONTAL} gap={Frame.GAPS.XS} align={Frame.ALIGNMENTS.CENTER_SPREAD}>
          <Panel.Divider />
          or
          <Panel.Divider />
        </Frame>

        <Link
          id="submit_social_button"
          href="#"
          onClick={() => trackGoogleSignupClickAndRedirect()}
          style={Link.COLORS.SECONDARY}
          removeUnderline={true}
          className="full-width"
        >
          <Frame border={Frame.BORDERS.DEFAULT} style={{ borderRadius: '10px', padding: '8px 16px', boxShadow: '0px 0px 0px 1px #D3D5D9' }} direction={Frame.DIRECTIONS.HORIZONTAL} align={Frame.ALIGNMENTS.CENTER_CENTER} gap={Frame.GAPS.MD}>
            <img
              src="https://assets-global.website-files.com/5db0d55a083f4b7cd59d2e42/641e0385b098d148731e65bc_Screen%20Shot%202023-03-24%20at%204.09.04%20PM.png"
              loading="lazy"
              alt=""
              className="popup_social-icon"
              style={{ height: '1.4rem', marginRight: '-15px' }}
            />
            <div style={{ textDecoration: 'none' }} id="google_div">Continue with Google</div>
          </Frame>

        </Link>
      </>
    );
  };

  return (
    <>
      {renderGoogleSocialButton()}
    </>
  );
};
